// Claude: split from adminAPI.js — industry tree + seller/buyer mapping 14-04-2026
import { api } from "./config/axiosConfig.js";
import { store } from "../redux/Store.ts";

export const AdminIndustryAPI = {

  // Claude: Taxonomy API methods — tree CRUD + seller/buyer mapping 20-02-2026
  getIndustryStats: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/taxonomy/stats",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: tags list — unique productTypeTags with seller count; optional filter params 19-05-2026
  getTagsList: async (params = {}) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/admin/tags-list",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data;
  },

  // Claude: distinct seller HQ countries for tags-list filter dropdown 19-05-2026
  getTagsListCountries: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/admin/tags-list/countries",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: tags-list snapshot — single fetch for client-side filtering; cached in sessionStorage 19-05-2026
  getTagsListSnapshot: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/admin/tags-list/snapshot",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: cascading filter options for tags-list — country/industry/targetIndustry/targetDept in one call 19-05-2026
  getTagsListFilterOptions: async (params = {}) => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/admin/tags-list/filter-options",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data;
  },

  // Claude: department stats — open RFXs, buyers, sellers responded 18-04-2026
  getDepartmentStats: async () => {
    const { token } = store.getState().user;
    const response = await api.request({
      url: "/admin/department-stats",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  getIndustryTree: async (cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/taxonomy",
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  createIndustryNode: async (data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/taxonomy",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  updateIndustryNode: async (id, data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/taxonomy/${id}`,
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  deleteIndustryNode: async (id, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/taxonomy/${id}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  mapSellersToIndustry: async (data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/taxonomy/map",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  unmapSellerFromIndustry: async (industryId, sellerId, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/taxonomy/map/${industryId}/${sellerId}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Claude: buyer taxonomy mapping 20-02-2026
  mapBuyersToIndustry: async (data, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: "/taxonomy/buyer-map",
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    });
    return response.data;
  },

  unmapBuyerFromIndustry: async (industryId, buyerId, cancel = false) => {
    const { token } = await store.getState().user;
    const response = await api.request({
      url: `/taxonomy/buyer-map/${industryId}/${buyerId}`,
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

};
